import { authService } from '../services/auth.service';
import { NavigateFunction } from 'react-router-dom';

/**
 * Register the navigation callback with the auth service
 * @param navigate The navigate function from React Router
 */
export const registerNavigationCallback = (navigate: NavigateFunction) => {
  if (navigate) {
    authService.registerNavigateCallback((path: string) => {
      navigate(path);
    });
  }
};

/**
 * Checks if the user is authenticated and redirects to the appropriate page if needed
 * @param navigate The navigate function from React Router
 * @param isProtectedRoute Whether the current route requires authentication
 * @returns Whether the user is authenticated
 */
export const checkAuth = (navigate: NavigateFunction, isProtectedRoute: boolean = false): boolean => {
  // Register the navigation callback
  registerNavigationCallback(navigate);
  
  const isAuthenticated = authService.isAuthenticated();
  const user = authService.getUser();
  
  // If on a protected route and not authenticated, redirect to login
  if (isProtectedRoute && !isAuthenticated && navigate) {
    navigate('/login');
    return false;
  }
  
  // If authenticated and on login page, redirect to appropriate dashboard
  if (isAuthenticated && window.location.pathname === '/login' && navigate) {
    const path = authService.getRolePath(user?.role || '');
    navigate(path);
    return true;
  }
  
  return isAuthenticated;
};

/**
 * Redirects the user to the appropriate page based on their role
 * @param navigate The navigate function from React Router
 */
export const redirectToRolePage = (navigate: NavigateFunction): void => {
  if (!navigate) return;
  
  const user = authService.getUser();
  
  if (user) {
    const path = authService.getRolePath(user.role);
    navigate(path);
  }
}; 